module.exports = __webpack_public_path__ + "img/header_hoken.f5d28493.png";